module.exports = __webpack_public_path__ + "img/superadmin.bbf643a5.svg";